const PageLoginCiashop = () => import('./PageLoginCiashop');

export default {
  path: '/ciashop',
  name: 'ciashop',
  component: PageLoginCiashop,
  meta: {
    title: 'Login Cia Shop',
  },
};



// WEBPACK FOOTER //
// ./src/features/public/login/ciashop/routes.js